import styled, { keyframes } from "styled-components";

export const Input = styled.input`
  visibility: hidden;
`;

export const Label = styled.label`
  position: relative;
  display: inline-block;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
`;

export const rotate = keyframes`
 from {
    opacity: 0;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(45deg);
  }
`;

export const Indicator = styled.span`
  width: 1.5em;
  height: 1.5em;
  background: ${props =>
    props.isChecked
      ? props.checkedBgColor
        ? props.checkedBgColor
        : "linear-gradient(208deg, #7B7BF8 9.51%, #9F60FE 88.04%)"
      : props.accentColor
      ? props.accentColor
      : "#342788"};
  position: absolute;
  top: 0em;
  left: -1em;
  border: ${props => (props.hasError ? "1px solid red" : "2px solid #6A5DBD")};
  border-radius: 4px;

  ${Input}:not(:disabled):checked & {
    background: #d1d1d1;
  }
  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${Input}:checked + &::after {
    display: block;
    top: 0.1em;
    left: 0.35em;
    width: 35%;
    height: 70%;
    border: solid #fff;
    border-width: 0 0.2em 0.2em 0;
    animation-name: ${rotate};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
  &::disabled {
    cursor: not-allowed;
  }
`;
